import { Box, BoxProps } from "@chakra-ui/react";

export function EyeIcon({
  width = 16,
  height = 16,
  color = "#676879",
  ...props
}: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3626 7.863C14.5653 8.14721 14.6666 8.28932 14.6666 8.49967C14.6666 8.71003 14.5653 8.85214 14.3626 9.13635C13.4519 10.4134 11.1261 13.1663 7.99998 13.1663C4.87383 13.1663 2.54804 10.4134 1.63734 9.13635C1.43466 8.85214 1.33331 8.71003 1.33331 8.49967C1.33331 8.28932 1.43466 8.14721 1.63734 7.863C2.54804 6.58597 4.87383 3.83301 7.99998 3.83301C11.1261 3.83301 13.4519 6.58597 14.3626 7.863Z"
          stroke="#676879"
        />
        <path
          d="M9.99997 8.5C9.99997 7.39543 9.10454 6.5 7.99997 6.5C6.8954 6.5 5.99997 7.39543 5.99997 8.5C5.99997 9.60457 6.8954 10.5 7.99997 10.5C9.10454 10.5 9.99997 9.60457 9.99997 8.5Z"
          stroke="#676879"
        />
      </svg>
    </Box>
  );
}
